import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddDocumentCetateanComponent } from './add-document-cetatean/add-document-cetatean.component';
import { DocumenteCetateanComponent } from './documente-cetatean.component';
import { EditDocumentCetateanComponent } from './edit-document-cetatean/edit-document-cetatean.component';
import { EditFisiereDocumentCetateanComponent } from './edit-fisiere-document-cetatean/edit-fisiere-document-cetatean.component';
import { IstoricDocumentCetateanComponent } from './istoric-document-cetatean/istoric-document-cetatean.component';

@NgModule({
    declarations: [
        DocumenteCetateanComponent,
        AddDocumentCetateanComponent,
        EditDocumentCetateanComponent,
        EditFisiereDocumentCetateanComponent,
        IstoricDocumentCetateanComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [DocumenteCetateanComponent],
})
export class DocumenteCetateanModule { }
